export const WAIVER_SUBMISSION_STATUS = {
  PENDING: "pending",
  PARTIALLY_SIGNED: "partially_signed",
  UNSIGNED: "Unsigned",
  SIGNED: "Signed"
}
